export default class SupervisorModel {
    idNSupervisor: number | null;
    fkNInstalacion: number | null;
    fkNVersion: number | null;
    fldTNombre: string | null;
    fldTVariableReceptoraNX: string | null;
    fldTIp: string | null;
    fldDUltimaTransmisionRecibida: Date | null;

    constructor() {
        this.idNSupervisor = null;
        this.fkNInstalacion = null;
        this.fkNVersion = null;
        this.fldTNombre = null;
        this.fldTVariableReceptoraNX = null;
        this.fldTIp = null;
        this.fldDUltimaTransmisionRecibida = null;
    }



}